<template>
  <div>
    <div class="top">
      <Button type="primary" ghost @click="backPage()">返回</Button>
    </div>
    <iframe :src="url" class="iframe"></iframe>
    <div class="footer-box">
      <div class="btn-box">
        <div class="import-btn" v-if="detailData.isImport == 0" @click="$refs.importArticleRef.open(itemData, 0)">导入</div>
        <div class="import-release" v-if="detailData.isImport == 0" @click="$refs.importArticleRef.open(itemData, 1)">导入并发布</div>
        <div class="imported" v-if="detailData.isImport == 1 && !detailData.publish">已导入</div>
        <div class="imported-release" v-if="detailData.isImport == 1 && detailData.publish">已导入并发布</div>
      </div>
    </div>

    <!-- 导入 -->
    <articleMaterialsImport ref="importArticleRef" @success="getDetail()"></articleMaterialsImport>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import articleMaterialsImport from './articleMaterialsImport';
export default {
  mixins: [common],
  components: {
    articleMaterialsImport
  },
  data() {
    return {
      url: '',
      itemData: {},
      detailData: {}
    };
  },
  created() {
    const { url, id, title } = this.$route.query;
    this.url = url;
    this.itemData.id = id;
    this.itemData.title = title;
    this.getDetail();
  },
  methods: {
    // 获取详情
    getDetail() {
      this.$http({
        url: '/buz/cms/materialsLibrary/queryArticleDetail',
        type: 'GET',
        data: {
          articleId: this.itemData.id
        }
      }).then(res => {
        this.detailData = res.data;
      });
    },

    backPage() {
      this.back('/contentManagement/publicMaterialLibrary');
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  display: flex;
  padding: 10px 20px 0 0;
  background: #fff;
  Button {
    margin-left: auto;
  }
}
.iframe {
  width: 100%;
  height: 91vh;
  border: none;
}
.footer-box {
  height: 70px;
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-box {
    width: 260px;
    display: flex;
    justify-content: space-between;
    .import-btn {
      cursor: pointer;
      width: 125px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 2px;
      font-size: 13px;
      color: #fff;
      background: #236dff;
    }
    .import-release {
      cursor: pointer;
      width: 125px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 2px;
      font-size: 13px;
      color: #fff;
      background: #236dff;
    }
    .imported {
      cursor: no-drop;
      border: 1px solid #ced1d5;
      color: #a8adb7;
      width: 125px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 2px;
      font-size: 13px;
    }
    .imported-release {
      cursor: no-drop;
      border: 1px solid #ced1d5;
      color: #a8adb7;
      width: 125px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 2px;
      font-size: 13px;
    }
  }
}
</style>
